export const MONTHS = [
  {
    key: 1,
    numeric: '01',
    value: 'January',
    short: 'Jan',
  },
  {
    key: 2,
    numeric: '02',
    value: 'February',
    short: 'Feb',
  },
  {
    key: 3,
    numeric: '03',
    value: 'March',
    short: 'Mar',
  },
  {
    key: 4,
    numeric: '04',
    value: 'April',
    short: 'Apr',
  },
  {
    key: 5,
    numeric: '05',
    value: 'May',
    short: 'May',
  },
  {
    key: 6,
    numeric: '06',
    value: 'June',
    short: 'Jun',
  },
  {
    key: 7,
    numeric: '07',
    value: 'July',
    short: 'Jul',
  },
  {
    key: 8,
    numeric: '08',
    value: 'August',
    short: 'Aug',
  },
  {
    key: 9,
    numeric: '09',
    value: 'September',
    short: 'Sep',
  },
  {
    key: 10,
    numeric: '10',
    value: 'October',
    short: 'Oct',
  },
  {
    key: 11,
    numeric: '11',
    value: 'November',
    short: 'Nov',
  },
  {
    key: 12,
    numeric: '12',
    value: 'December',
    short: 'Dec',
  },
]
